<template>
      
      <!-- Begin page -->
      <div id="wrapper">
            
            <!-- Top Bar Start -->
            <topbar></topbar>
            <!-- Top Bar End -->
            
            
            <!-- ========== Left Sidebar Start ========== -->
            
            <!-- Left Sidebar End -->
            <left></left>
            
            
            <!-- ============================================================== -->
            <!-- Start right Content here -->
            <!-- ============================================================== -->
            
            
            <div class="content-page">
                  <!-- Start content -->
                  <div class="content">
                        <div class="container-fluid">
                              
                              <div class="row">
                                    <div class="col-12">
                                          <div class="page-title-box">
                                                <h4 class="page-title float-left">认证专区</h4>
                                                
                                                <ol class="breadcrumb float-right">
                                                      <li class="breadcrumb-item"><a href="#">cpwm</a></li>
                                                      <li class="breadcrumb-item"><a href="#">认证专区</a></li>
                                                      <li class="breadcrumb-item active">再认证</li>
                                                </ol>
                                                
                                                <div class="clearfix"></div>
                                          </div>
                                    </div>
                              </div>
                              
                              <div class="row">
                                    <div class="col-12">
                                          <div class="card-box table-responsive">
                                                <p class="text-muted font-14 m-b-30" style="text-align: center">
                                                      <img src="t2.png"  width="100%" >
                                                </p>
                                                <div class="tishi1" style="text-align: left;margin-top:0px;margin-bottom:30px;">
                                                      <div style="width: 80%;margin: 0 auto;line-height: 1.5rem;text-align: center;">
                                                      <img src="4.jpg" style="width: 15px;margin-right: 3px;">重要提醒：线上学习绑定的手机号须与登录该系统时使用的手机号一致才会显示已获得的学时。若您使用了不同的手机号码时，请点击<a href="javascript:void(0);" v-on:click="showmobilefun">绑定手机号码</a>。如遇问题，请拨打官方电话021-31190952。
                                                      </div>
                                                </div>
                                              
                                                <div id="datatable-buttons_wrapper"
                                                     class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                                                      <div class="row">
                                                            <div class="col-sm-12">
                                                                  <table id="datatable-buttons"
                                                                         class="table table-striped table-bordered dataTable no-footer"
                                                                         cellspacing="0" width="100%" role="grid"
                                                                         aria-describedby="datatable-buttons_info"
                                                                         style="width: 100%;text-align: center">
                                                                        <thead>
                                                                        <tr role="row">
                                                                              <th class="sorting_asc" tabindex="0"
                                                                                  aria-controls="datatable-buttons"
                                                                                  rowspan="1" colspan="1"
                                                                                  aria-sort="ascending"
                                                                                  aria-label="Name: activate to sort column descending"
                                                                                  style="width: 203px;">姓名
                                                                              </th>
                                                                              <th class="sorting" tabindex="0"
                                                                                  aria-controls="datatable-buttons"
                                                                                  rowspan="1" colspan="1"
                                                                                  aria-label="Position: activate to sort column ascending"
                                                                                  style="width: 310px;">授权机构
                                                                              </th>
                                                                              <th class="sorting" tabindex="0"
                                                                                  aria-controls="datatable-buttons"
                                                                                  rowspan="1" colspan="1"
                                                                                  aria-label="Position: activate to sort column ascending"
                                                                                  style="width: 310px;">学习内容
                                                                              </th>
                                                                              <th class="sorting" tabindex="0"
                                                                                  aria-controls="datatable-buttons"
                                                                                  rowspan="1" colspan="1"
                                                                                  aria-label="Office: activate to sort column ascending"
                                                                                  style="width: 149px;">学习时间
                                                                              </th>
                                                                              <th class="sorting" tabindex="0"
                                                                                  aria-controls="datatable-buttons"
                                                                                  rowspan="1" colspan="1"
                                                                                  aria-label="Age: activate to sort column ascending"
                                                                                  style="width: 77px;">学时
                                                                              </th>
                                                                        </tr>
                                                                        </thead>
                                                                        
                                                                        
                                                                        <tbody>
                                                                        
                                                                        
                                                                        <tr role="row" class="odd"  v-for="item in onlinestudayfy.data">
                                                                              <td class="sorting_1">{{item.name}}</td>
                                                                              <td>大单道</td>
                                                                              <td>{{item.title}}</td>
                                                                              <td>{{item.created_at}}</td>
                                                                              <td>{{item.credit}}</td>
                                                                        </tr>
                                                                        <tr role="row" class="even"  v-for="item in offlinestudayfy.data">
                                                                              <td class="sorting_1">{{item.name}}</td>
                                                                              <td>陆家嘴财富管理培训中心</td>
                                                                              <td>{{item.classname}}</td>
                                                                              <td>{{item.created_at}}</td>
                                                                              <td>{{item.classtime}}</td>
                                                                        </tr>
                                                                        </tbody>
                                                                  </table>
                                                            </div>
                                                      </div><!--
                                                      <div class="row" style="text-align: right">
                                                           
                                                           
                                                           <div class="col-sm-12 col-md-5">
                                                                 <div class="dataTables_info"
                                                                      id="datatable-buttons_info" role="status"
                                                                      aria-live="polite">
                                                                       <b>累计学时</b>：{{xueshi}}
                                                                 </div>
                                                           </div>
                                                          
                                                           <div class="col-sm-12 col-md-7" style="display: none">
                                                                 <div class="dataTables_paginate paging_simple_numbers"
                                                                      id="datatable-buttons_paginate">
                                                                       <ul class="pagination">
                                                                             <li class="paginate_button page-item previous "
                                                                                 id="datatable-buttons_previous"><a
                                                                                   href="javascript:void(0)"
                                                                                   aria-controls="datatable-buttons"
                                                                                   data-dt-idx="0" tabindex="0"
                                                                                   class="page-link"
                                                                                   v-on:click="toonlinepage(onlinestudayfy.current_page-1)"
                                                                                   v-if="onlinestudayfy.current_page>1"
                                                                             >上一页</a></li>
                                                                             <li class="paginate_button page-item "
                                                                                 v-for="count in onlinestudayfy.last_page"
                                                                                 v-if="count < onlinestudayfy.current_page +6 && count>onlinestudayfy.current_page -6"
                                                                                 :class="count==onlinestudayfy.current_page?'active':''"
                                                                             >
                                                                                   <a href="javascript:void(0)"
                                                                                      aria-controls="datatable-buttons"
                                                                                      data-dt-idx="1" tabindex="0"
                                                                                      class="page-link" v-on:click="toonlinepage(count)">{{count}}</a></li>
                                                                        
                                                                           
                                                                             <li class="paginate_button page-item next"
                                                                                 id="datatable-buttons_next"><a
                                                                                   href="javascript:void(0)"
                                                                                   aria-controls="datatable-buttons"
                                                                                   data-dt-idx="7" tabindex="0"
                                                                                   class="page-link"
                                                                                   v-on:click="toonlinepage(onlinestudayfy.current_page+1)"
                                                                                   v-if="onlinestudayfy.current_page<onlinestudayfy.last_page"
                                                                             >下一页</a></li>
                                                                       </ul>
                                                                 </div>
                                                           </div>
                                                          
                                                      </div> -->
                                                      <div style="width: 100%;float:left;padding:20px;text-align: right;" >
                                                            <b>累计学时</b>：{{xueshi}}
                                                      </div>
                                                      <div style="width: 100%;float:left;padding:20px;text-align: right;" >
                                                            <button type="submit" style="margin: 0 auto;" class="btn btn-gradient btn-rounded waves-light waves-effect w-md"  v-on:click="tj">确认提交</button>
                                                      </div>
                                                </div>
                                               
                                          </div>
                                          
                                    
                                    </div>
                              </div>
                        
                        
                        
                        </div> <!-- container -->
                  
                  </div> <!-- content -->
                  
                  <!--footer-->
            
            </div>
            
            
            <!-- ============================================================== -->
            <!-- End Right content here -->
            <!-- ============================================================== -->
            <!--中间弹窗-->
            <div class="tanchuang" v-if="showmobile">
                  <h2>绑定手机号</h2>
                  <div class="mbcontent">
                        <div class="mtel">授权机构：</div>
                        <div class="mtelinput">
                              <select style="border: 0px;height: 38px;">
                                    <option value="大单道">大单道</option>
                              </select>
                              
                        </div>
                        <div class="mtel">手机号：</div>
                        <div class="mtelinput"><input type="text" name="mobile"  class="form-control" placeholder="您的手机号码" v-model="mobile"></div>
                        <div class="mtel">验证码：</div>
                        <div class="mtelinput2"><input type="text" name="yzm" class="form-control" placeholder="手机验证码" v-model="yzm"></div>
                        <div class="mtelinput3" v-html="requestsmsH" v-if="sendAuthCode"  v-on:click="requestsms"></div>
                        <div class="mtelinput3" v-html="requestsmsH" v-if="!sendAuthCode"></div>
                  </div>
                  <ul>
                        <li style="margin-top:40px;">
                              <button type="submit" style="margin: 0 auto;"
                                      class="btn btn-gradient btn-rounded waves-light waves-effect w-md"
                                      v-on:click="bangding">绑定手机
                              </button>
                        </li>
                  </ul>
                  <div class="tishi1" v-if="bdresult==false"><img src="4.jpg" style="width: 14px;">{{bdresult_msg}}</div>
            </div>
      
      </div>
      <!-- END wrapper -->


</template>

<script>
      import topbar from './topbar';
      import left from './left';

      export default {
            name: 'sss',
            components: {topbar, left},
            data() {
                  return {
                        requestsmsH: '获取验证码',
                        sendAuthCode: true,
                        bdmobile:false,
                        mobile:'',
                        yzm:'',
                        onlinestudayfy:'',
                        offlinestudayfy:'',
                        pageonline:1,
                        pageoffline:1,
                        showmobile:false,

                        bdresult:true,
                        bdresult_msg:this.bdresult_msg,
                        
                        xueshi:this.xueshi,
                  }
            },
            mounted() {
                  this.checkpower();
                  this.checkmobile();
                  this.onlinestuday();
                  
                

            },
            methods: {
                  showmobilefun:function(){
                        if(this.bdmobile){
                              this.showmobile=true;
                        }else{
                              swal(
                                    {
                                          title: '您已经绑定了手机号，请勿重复操作。',
                                          text: '',
                                          type: 'warning',
                                          confirmButtonColor: '#4fa7f3',
                                    }
                              )
                        }
                        
                  },
                  checkpower: function () {

                        this.$axios({
                              method: 'get',
                              url: '/api/member2/Authentication2_check',
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {
                              if(response.data.code==1){
                                    window.location.href = '#/Authentication_show?key=' + response.data.msg;
                              }else if(response.data.code==2){
                                    window.location.href="#/Authentication_show?key=3";
                              }else if(response.data.code==3){
                                    window.location.href="#/Authentication_show?key=4";
                              }else if(response.data.code==4){
                                    //这里不弹框
                              }else if(response.data.code==5){
                                    //直接跳转到填写地址那里
                                    window.location.href="#/Authentication2_step4?out_trade_no="+response.data.orderid;
                              }else if(response.data.code==6){
                                    //直接跳转到填写地址那里
                                    window.location.href="#/Authentication2_step3";
                              }

                        }.bind(this)).catch(function OnError() {

                        })

                  },
                  checkmobile: function () {
                        this.$axios({
                              method: 'get',
                              url: '/api/member2/member_show',
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {
                              //console.log('xx:'+response.data.user.wechattel);
                              if(response.data.user.wechattel==null){
                                    this.bdmobile=true;
                              }else{
                                    this.bdmobile==false;
                              }
                        }.bind(this)).catch(function OnError() {

                        })

                  },
                  requestsms: function () {
                        if (this.mobile == null) {
                              alert('手机号不能为空！');
                              return false;
                        }
                        this.$axios({
                              method: 'get',
                              url: '/api/member2/sendbdwechat/' + this.mobile
                        }).then(function onSuccess(response) {
                              //console.log(response.data.code);
                              if (response.data.code === '0') {
                                    this.requestsmsdaoshu();
                              } else {
                                    alert('短信发送失败，请稍后尝试，或者联系系统管理员');
                              }

                        }.bind(this)).catch(function onError() {
                              alert('短信发送失败，请稍后尝试，或者联系系统管理员');
                        })
                  },
                  requestsmsdaoshu: function () {
                        this.sendAuthCode = false;
                        this.requestsmsH = '60秒后重新发送'
                        var miao = 60;
                        var stopinterval = setInterval(() => {
                              miao--;
                              if (miao > 0) {
                                    this.requestsmsH = miao + '秒后重新发送';
                              } else {
                                    this.sendAuthCode = true;
                                    this.requestsmsH = '获取验证码';
                                    clearInterval(stopinterval);
                              }

                        }, 1000);

                  },
                  bangding: function () {
                        let data={
                              mobile:this.mobile,
                              yzm:this.yzm,
                        }
                        this.$axios({
                              method: 'post',
                              data:data,
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              },
                              url: '/api/member2/bdmobile/'
                        }).then(function onSuccess(response) {
                              if (response.data.code == 1) {
                                    this.bdresult=false;
                                    this.bdresult_msg=response.data.msg;
                                    
                              }else{
                                    this.bdresult=true;
                                    
                                    this.bdmobile=false;
                                    this.onlinestuday();
                                    //console.log(this.bdmobile)
                                    this.showmobile=false;
                              }
                        }.bind(this)).catch(function onError() {
                              alert('短信发送失败，请稍后尝试，或者联系系统管理员');
                        })
                  },
                  onlinestuday: function () {
                        this.$axios({
                              method: 'get',
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              },
                              url: '/api/member2/onlinestuday?page='+this.pageonline,
                        }).then(function onSuccess(response) {
                              this.onlinestudayfy=response.data;
                              this.offlinestuday();
                              
                        }.bind(this)).catch(function onError() {
                        
                        })
                  },
                  offlinestuday: function () {
                        this.$axios({
                              method: 'get',
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              },
                              url: '/api/member2/offlinestuday?page='+this.pageoffline,
                        }).then(function onSuccess(response) {
                              this.offlinestudayfy=response.data;

                              let a=parseFloat(this.onlinestudayfy.sumcredit*100);
                              let b=parseFloat(this.offlinestudayfy.sumclasstime*100)
                              if(!a){a=0}
                              if(!b){b=0}
                              this.xueshi=(a+b)/100;
                        }.bind(this)).catch(function onError() {

                        })
                  },
                  toonlinepage: function (page) {
                        this.pageonline = page;
                        this.onlinestuday();
                  },
                  toofflinepage: function (page) {
                        this.pageoffline = page;
                        this.offlinestuday();
                  },
                  tj: function () {
                        let data={
                              xueshi:this.xueshi,
                        }
                        this.$axios({
                              method: 'post',
                              data:data,
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              },
                              url: '/api/member2/Authentication2_tj'
                        }).then(function onSuccess(response) {
                              if(response.data.code==1){
                                    swal(
                                          {
                                                title: response.data.msg,
                                                text: '',
                                                type: 'warning',
                                                confirmButtonColor: '#4fa7f3',
                                          }
                                    )
                              }else{
                                    window.location.href = "/member2/#/Authentication2_step3";
                              }
                        
                        }.bind(this)).catch(function onError() {
                        
                        })
                  },
                  
                  


            }
            //mounted over


      }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
      .zx {
            width: 100%;
      }
      
      .zx li {
            width: 100%;
            float: left
      }
      
      .inputself {
            width: 49%;
            margin-right: 1%;
            float: left
      }
      
      .tishi1 {
            color: #477ed1;
            float: left;
            margin-top: 30px;
      }
      
      .tanchuang {
            border: 1px solid #0000ff;
            top: 30%;
            position: fixed;
            width: 30%;
            left: 35%;
            background-color: #ffffff;
            padding: 1%;
            z-index: 100;
            border-radius: 20px;
            
      }
      
      .tanchuang h2 {
            font-size: 18px;
            color: #467fd2;
            text-align: center;
            line-height: 42px;
            font-weight: bold;
      }
      
      .tanchuang ul {
            margin: 20px;
      }
      
      .tanchuang li {
            line-height: 32px;
            text-align: center;
            width: 100%;
            float: left;
      }
      
      .tanchuang li p {
            line-height: 40px;
      }
      
      .tanchuang .pass {
            height: 22px;
      }
      
      .tanchuang .buttonclass {
            margin: 0 30px;
            padding: 0 10px;
      }
      
      .mtel {
            width: 30%;
            float: left;
            text-align: center;
            line-height: 35px;
            margin: 5px 0;
      }
      
      .mtelinput {
            width: 70%;
            float: left;
            margin: 5px 0;
      }
      
      .mtelinput2 {
            width: 30%;
            float: left;
            margin: 5px 0;
      }
      
      .mtelinput3 {
            width: 25%;
            float: left;
            margin: 5px 0;
            line-height: 35px;
            background-color: #467fd2;
            color: #ffffff;
            text-align: center;
      }
      
      .tishi1 {
            color: #000000;
            float: left;
           
            width: 100%;
            text-align: center;
      }
      .tishi1 a{color:#477ed1;font-weight: bold;text-decoration: underline}
      

</style>



// WEBPACK FOOTER //
// src/components/Authentication2_step2.vue